import { sortByRecent } from "../helpers/sortByRecent.helper";

const firstDefined = (...values) =>
  values.find((value) => value !== undefined && value !== null && value !== "");

export const unwrapTenantPayload = (payload = {}) => {
  if (!payload || typeof payload !== "object") return {};
  if (Array.isArray(payload)) return payload;
  if (payload.id || payload._id || payload.name || payload.tenantName) return payload;
  if (payload.data && typeof payload.data === "object") return unwrapTenantPayload(payload.data);
  if (payload.tenant && typeof payload.tenant === "object") return unwrapTenantPayload(payload.tenant);
  return payload;
};

const toBoolean = (value, fallback = false) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value !== 0;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (["true", "1", "yes", "enabled", "active"].includes(normalized)) return true;
    if (["false", "0", "no", "disabled", "inactive"].includes(normalized)) return false;
  }
  return fallback;
};

export const normalizeTenant = (rawInput = {}) => {
  const raw = unwrapTenantPayload(rawInput);
  const id = String(firstDefined(raw.id, raw._id, "") || "");
  const name = firstDefined(raw.name, raw.tenantName, raw.label, "");

  return {
    ...raw,
    id,
    name,
    email: firstDefined(raw.email, ""),
    mobile: firstDefined(raw.mobile, ""),
    contactPerson: firstDefined(raw.contactPerson, raw.contact, ""),
    enabled: toBoolean(
      firstDefined(raw.enabled, raw.isEnabled, raw.active),
      false
    ),
    dns: firstDefined(raw.dns, ""),
    slug: String(firstDefined(raw.tenantId, raw.slug, name, id) || "").trim(),
    creationDate: firstDefined(
      raw.createdAt,
      raw.creationDate,
      raw.createdDate,
      raw.createdOn
    ),
    lastModifiedDate: firstDefined(
      raw.updatedAt,
      raw.lastModifiedDate,
      raw.lastModified
    ),
  };
};

export const pickDefaultTenant = (tenants = []) => {
  const list = Array.isArray(tenants) ? tenants : [];
  const matchValue = (tenant, value) => {
    const slug = String(tenant.slug || "").trim().toLowerCase();
    const name = String(tenant.name || "").trim().toLowerCase();
    return slug === value || name === value;
  };
  return (
    list.find((tenant) => matchValue(tenant, "default")) ||
    list.find((tenant) => tenant.enabled) ||
    list[0] ||
    null
  );
};

export const normalizeTenantList = (payload) => {
  const source = unwrapTenantPayload(payload);
  const list = Array.isArray(source)
    ? source
    : Array.isArray(source?.data)
      ? source.data
      : Array.isArray(source?.tenants)
        ? source.tenants
        : Array.isArray(payload)
          ? payload
          : [];
  return sortByRecent(list.map(normalizeTenant));
};
